import type { Permiso } from '@barbones/shared';
import {
  BadgeCheck,
  BarChart3,
  Boxes,
  CalendarDays,
  ContactRound,
  House,
  Settings,
  UsersRound,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export interface SeccionModulo {
  to: string;
  etiqueta: string;
  icono: LucideIcon;
  /** Si se indica, basta con tener cualquiera de estos permisos. */
  permisos?: Permiso[];
  palabrasClave?: string;
}

export interface Modulo {
  id: string;
  etiqueta: string;
  to: string;
  icono: LucideIcon;
  permisos?: Permiso[];
  secciones?: SeccionModulo[];
}

/** Mapa de navegación del ERP. El menú lateral existe solo dentro de cada módulo (ERS §9.3). */
export const MODULOS: Modulo[] = [
  { id: 'inicio', etiqueta: 'Inicio', to: '/', icono: House },
  { id: 'agenda', etiqueta: 'Agenda', to: '/agenda', icono: CalendarDays, permisos: ['agenda.ver', 'agenda.ver_propia'] },
  { id: 'caja', etiqueta: 'Caja', to: '/caja', icono: Wallet, permisos: ['caja.operar', 'ventas.cobrar'] },
  { id: 'clientes', etiqueta: 'Clientes', to: '/clientes', icono: ContactRound, permisos: ['clientes.ver'] },
  { id: 'inventario', etiqueta: 'Inventario', to: '/inventario', icono: Boxes, permisos: ['inventario.ver'] },
  { id: 'personal', etiqueta: 'Personal', to: '/personal', icono: UsersRound, permisos: ['personal.ver', 'nomina.ver'] },
  { id: 'aprobaciones', etiqueta: 'Aprobaciones', to: '/aprobaciones', icono: BadgeCheck, permisos: ['aprobaciones.resolver'] },
  {
    id: 'reportes',
    etiqueta: 'Reportes',
    to: '/reportes',
    icono: BarChart3,
    permisos: ['reportes.dueno', 'reportes.recepcion', 'reportes.propios'],
  },
  {
    id: 'configuracion',
    etiqueta: 'Configuración',
    to: '/configuracion',
    icono: Settings,
    permisos: ['config.ver', 'usuarios.gestionar'],
  },
];

export function tieneAlguno(permisos: readonly Permiso[], requeridos?: readonly Permiso[]): boolean {
  return !requeridos || requeridos.length === 0 || requeridos.some((p) => permisos.includes(p));
}
